import styled from 'styled-components';
import { Button, AutoComplete } from 'antd';

export const MetaTagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const MetaTagsInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 10px;
`;

export const KeyInputContainer = styled.div`
  flex: 1;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  
  .ant-select {
    width: 100%;
  }
  
  .ant-select-selector {
    background-color: #fff !important;
    border-radius: 4px !important;
    min-height: 32px !important;
    
    &:hover {
      border-color: #bfbfbf !important;
    }
  }
  
  .ant-select-focused .ant-select-selector {
    box-shadow: none !important;
  }

  .ant-select-search__field__wrap {
    display: block;
  }
  
  .ant-input {
    background-color: transparent !important;
    border-radius: 4px !important;
    height: 32px !important;
    
    &:hover {
      border-color: #bfbfbf !important;
    }
    
    &:focus {
      border-color: #bfbfbf !important;
      box-shadow: none !important;
    }
  }
  
  .ant-select-selection-placeholder,
  .ant-select-selection__placeholder {
    color: rgba(0, 0, 0, 0.45) !important;
    z-index: 1 !important;
  }
  
  ${props => props.hasError && `
    .ant-select-selector {
      border-color: #ff4d4f !important;
      
      &:hover {
        border-color: #ff4d4f !important;
      }
    }
    
    .ant-select-focused .ant-select-selector {
      border-color: #ff4d4f !important;
      box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
    }
    
    .ant-input {
      border-color: #ff4d4f !important;
      
      &:hover {
        border-color: #ff4d4f !important;
      }
      
      &:focus {
        border-color: #ff4d4f !important;
        box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
      }
    }
  `}
`;

export const ErrorMessage = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
  min-height: 18px;
  display: block;
`;

export const ValueInputContainer = styled.div`
  flex: 1;
  min-width: 120px;
  
  .ant-select {
    width: 100%;
  }
  
  .ant-select-selector {
    background-color: #fff !important;
    border-radius: 4px !important;
    min-height: 32px !important;
    
    &:hover {
    }
  }
  
  .ant-select-focused .ant-select-selector {
    border-color: #bfbfbf !important;
    box-shadow: none !important;
  }

  .ant-select-search__field__wrap {
    display: block;
  }
  
  .ant-input {
    background-color: transparent !important;
    border-radius: 4px !important;
    height: 32px !important;
    
    &:hover {
      border-color: #bfbfbf !important;
    }
    
    &:focus {
      border-color: #bfbfbf !important;
      box-shadow: none !important;
    }
  }
  
  .ant-select-selection-placeholder,
  .ant-select-selection__placeholder {
    color: rgba(0, 0, 0, 0.45) !important;
    z-index: 1 !important;
  }
`;

export const AddButton = styled(Button)`
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: rgb(223, 76, 53) !important;
  border-color: rgb(223, 76, 53) !important;
  border-radius: 4px !important;
  flex-shrink: 0 !important;
  
  .anticon,
  .anticon-plus {
    color: #ffffff !important;
    font-size: 14px !important;
    display: inline-block !important;
    line-height: 1 !important;
  }
  
  &:hover,
  &:focus {
    background-color:rgb(223, 76, 53) !important;
    border-color: rgb(223, 76, 53) !important;
    
    .anticon,
    .anticon-plus {
      color: #ffffff !important;
    }
  }
  
  &:disabled {
    background-color: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
    
    .anticon,
    .anticon-plus {
      color: #999 !important;
    }
  }
`;

